import React from 'react';
import PropTypes from 'prop-types';

export default function TimelineContainer({ children }) {
  return (
    <div className="m-timeline-1 m-timeline-1--fixed">
      <div className="m-timeline-1__items">
        <div className="m-timeline-1__marker" />
        {children}
      </div>
    </div>
  );
}

TimelineContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
